// 公司地图配置数据
export const mapItems = [
  {
    name: "美洲",
    position: {
      top: "173px",
      left: "198px",
    },
    dialogStyle: {
      width: "158px",
      height: "276px",
    },
    nations: [
      {
        region: "北美",
        countries: ["美国", "加拿大", "墨西哥", "巴拿马"],
        style: {
          "margin-right": "20px",
        },
      },
      {
        region: "南美",
        countries: ["巴西", "阿根廷", "智利", "乌拉圭", "委内瑞拉", "秘鲁"],
        style: {},
      },
    ],
  },
  {
    name: "欧洲",
    position: {
      top: "165px",
      left: "671px",
    },
    dialogStyle: {
      width: "400px",
      height: "336px",
      left: "-431px",
    },
    nations: [
      {
        region: "西欧",
        countries: ["英国", "法国", "荷兰", "比利时", "爱尔兰", "卢森堡"],
        style: {
          "margin-right": "20px",
          width: "42px",
        },
      },
      {
        region: "中欧",
        countries: ["德国", "瑞士", "奥地利", "捷克斯洛伐克", "匈牙利", "波兰"],
        style: {
          "margin-right": "20px",
          width: "84px",
        },
      },
      {
        region: "南欧",
        countries: [
          "意大利",
          "西班牙",
          "葡萄牙",
          "希腊",
          "罗马尼亚",
          "保加利亚",
          "克罗地亚",
          "斯洛文尼亚",
        ],
        style: {
          "margin-right": "20px",
          width: "70px",
        },
      },
      {
        region: "北欧",
        countries: ["丹麦", "瑞典", "芬兰", "冰岛"],
        style: {
          "margin-right": "20px",
          width: "28px",
        },
      },
      {
        region: "东欧",
        countries: ["俄罗斯", "乌克兰", "立陶宛", "拉脱维亚"],
        style: {
          width: "56px",
        },
      },
    ],
  },
  {
    name: "亚洲",
    position: {
      top: "169px",
      left: "900px",
    },
    dialogStyle: {
      width: "456px",
      height: "336px",
      left: "-485px",
    },
    nations: [
      {
        region: "东亚",
        countries: ["日本", "韩国", "中国台湾", "中国香港", "中国澳门", "蒙古"],
        style: {
          "margin-right": "20px",
          width: "56px",
        },
      },
      {
        region: "东南亚",
        countries: [
          "新加坡",
          "马来西亚",
          "泰国",
          "印度尼西亚",
          "越南",
          "菲律宾",
          "文莱",
          "缅甸",
        ],
        style: {
          "margin-right": "20px",
          width: "70px",
        },
      },
      {
        region: "南亚",
        countries: ["印度", "孟加拉", "巴基斯坦", "斯里兰卡", "尼泊尔"],
        style: {
          "margin-right": "20px",
          width: "56px",
        },
      },
      {
        region: "中亚",
        countries: ["哈萨克斯坦", "吉尔吉斯斯坦", "塔吉克斯坦", "乌兹别克斯坦"],
        style: {
          "margin-right": "20px",
          width: "84px",
        },
      },
      {
        region: "西亚",
        countries: [
          "沙特阿拉伯",
          "阿联酋",
          "阿曼",
          "阿塞拜疆",
          "阿富汗",
          "塞浦路斯",
          "土耳其",
        ],
        style: {
          width: "70px",
        },
      },
    ],
  },
  {
    name: "非洲",
    position: {
      top: "347px",
      left: "605px",
    },
    dialogStyle: {},
    nations: [
      {
        countries: ["南非", "埃及", "塞拉利昂", "尼日利亚"],
        style: {
          "margin-right": "20px",
          width: "56px",
        },
      },
      {
        countries: ["吉布提", "刚果(金)", "乌干达", "津巴布韦"],
        style: {
          width: "56px",
        },
      },
    ],
  },
  {
    name: "大洋洲",
    position: {
      top: "475px",
      left: "959px",
    },
    dialogStyle: {
      width: "138px",
      height: "150px",
      top: "-25px",
      left: "-167px",
    },
    nations: [
      {
        countries: ["新西兰", "澳大利亚", "巴布亚新几内亚"],
        style: {
          width: "98px",
        },
      },
    ],
  },
];

export default {
  mapItems,
};
